import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux'

import ARDetail from '../../components/AR/ARDetail';
import { fetchCustomers, fetchCustomerDetail } from '../../actions/customers_actions';
import { fetchARInvoices, createAR, editAR, deleteAR, fetchARDetail, fetchARCredits, clearCredits, clearARDetail } from '../../actions/arap_actions';
import { setDefaultOfForm } from '../../actions/purchaseOrders_actions';
import { checkPassword, clearCheckPassword } from '../../actions/settings_actions';

const isNumeric = function (n) {
    return !isNaN(parseFloat(n)) && isFinite(n);
};

const validate = (values, props) => {
  const errors = {}

  if(values.TotalPayment && !isNumeric(values.TotalPayment)) {
    errors.TotalPayment = 'Accept number only!'
  }

  if(values.TotalPayment <= 0) {
    errors.TotalPayment = 'Positive number only!'
  }

  if(values.Discount && !isNumeric(values.Discount)) {
    errors.Discount = 'Accept number only!'
  }

  if(values.Discount && values.Discount < 0) {
    errors.Discount = 'Positive number only!'
  }

  if(!values.Customer) {
    errors.Customer = 'Required'
  }

  if(!values.Account) {
    errors.Account = 'Required'
  }

  if(!values.TotalPayment) {
    errors.TotalPayment = 'Required'
  }

  if(!values.Method) {
    errors.Method = 'Required'
  }

  return errors;
}

const arDetail = reduxForm({
    form: 'arDetail',
    enableReinitialize: true,
    destroyOnUnmount: false,
    touchOnChange: true,
    touchOnBlur: false,
    validate,
})(ARDetail);
const selector = formValueSelector('arDetail')

function mapStateToProps(state) {
    const customer_id = selector(state, 'Customer');
    const credits = selector(state, 'Credits');

    const invoiceDate = selector(state, 'InvoiceDate');
    const fromDate = selector(state, 'FromDate');
    const toDate = selector(state, 'ToDate');

    const invoiceDateBySequence = selector(state, 'InvoiceDateBySequence');
    const fromDateBySequence = selector(state, 'FromDateBySequence');
    const toDateBySequence = selector(state, 'ToDateBySequence');

    const method = selector(state, 'Method');
    const checkNum = selector(state, 'CheckNum');
    const account = selector(state, 'Account');
    const discount = selector(state, 'Discount');
    const totalPayment = selector(state, 'TotalPayment');
    const waive = selector(state, 'Waive');
    const note = selector(state, 'Note');
    return {
        customer_id,
        credits,
        invoiceDate,
        fromDate,
        toDate,
        invoiceDateBySequence,
        fromDateBySequence,
        toDateBySequence,
        method,
        checkNum,
        account,
        discount,
        totalPayment,
        waive,
        note,
        invoices: state.arap.invoices,
        invoicesIsLoading: state.arap.invoicesIsLoading,
        invoicesError: state.arap.invoicesError,
        arCreated: state.arap.arCreated,
        arEdited: state.arap.arEdited,
        arCreateError: state.arap.arCreateError,
        arEditError: state.arap.arEditError,
        arIsCreating: state.arap.arIsCreating,
        arIsEditing: state.arap.arIsEditing,
        arDetail: state.arap.arDetail,
        initialValues: state.arap.arDetail,

        credits: state.arap.credits,
        creditsIsLoading: state.arap.creditsIsLoading,
        creditsError: state.arap.creditsError,

        customers: state.customers.all,
        customersIsLoading: state.customers.isLoading,
        customersError: state.customers.error,
        currentCustomerDetail: state.customers.currentCustomerDetail,
        userPermissions: state.auth.userPermissions,
        checkPassword: state.settings.checkPassword,
        checkPasswordSuccess: state.settings.checkPasswordSuccess,
        checkPasswordFailure: state.settings.checkPasswordFailure,
    }

}


export default connect(mapStateToProps, { fetchARInvoices, createAR, editAR, deleteAR, fetchCustomers, fetchCustomerDetail,
  fetchARDetail, fetchARCredits, clearCredits, clearARDetail, checkPassword, clearCheckPassword, setDefaultOfForm })(arDetail)



// WEBPACK FOOTER //
// ./master/jsx/containers/AR/ARDetail.jsx